module.exports = __webpack_public_path__ + "static/media/Home-Image-ETM.7a49cbdd.jpg";